import {Container} from "./Container"
import {FieldContainer} from "./FieldContainer"
import {Input} from "./Input"

export const ClaimCodeStyles = {
    Container: Container,
    FieldContainer: FieldContainer,
    Input: Input
}